import type { ExceptionField } from '@/api/cockpit';

export function formatMatchedSelectOptionLabel(
  field: ExceptionField,
  option: { value: string; label: string },
): string {
  if (field.matchedValue === option.value && field.confidence != null) {
    return `${option.label} (${Math.round(field.confidence * 100)}%)`;
  }
  return option.label;
}
